export default __webpack_public_path__ + "static/media/BackArrow.f74fec67.svg";